import React from 'react';
import PropTypes from 'prop-types';
import PrismInput from '../FormElements/PrismInput';
import { withFormsy } from 'formsy-react';
import formsyUtils from './utils/formsyUtils';

class FormsyPrismInput extends React.Component {
    constructor(props) {
        super(props);

        this._input = React.createRef();
    }

    componentDidUpdate() {
        if (this.props.autofocus && this.props.isPristine()) {
            this._input.current.focus();
        }
    }

    onBlur = (event) => {
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }

        if (this.props.isPristine()) {
            this.props.setValue(event.target.value);
        }
    }

    onChange = (event) => {
        this.props.setValue(event.target.value);

        if (this.props.onChange) {
            const isValidValue = this.props.isValidValue(event.target.value);

            this.props.onChange(event.target.value, isValidValue);
        }
    }

    render() {
        const {
            isValid,
            isPristine,
            isPaste,
            getValue,
            getErrorMessages,
            ...inputProps
        } = this.props;

        const value = getValue();
        const errors = getErrorMessages();
        const pristine = isPristine();
        const valid = isValid();
        const invalid = errors.length > 0 && !pristine;

        return (
            <PrismInput
                {...formsyUtils.cleanFormsyProps(inputProps)}
                innerRef={this._input}
                value={value}
                errors={errors}
                valid={valid}
                invalid={invalid}
                isPaste={isPaste}
                onChange={this.onChange}
                onBlur={this.onBlur}
            />
        );
    }
}

const PRISM_INPUT_PROPS = PrismInput.propTypes;
delete PRISM_INPUT_PROPS['valid'];
delete PRISM_INPUT_PROPS['invalid'];

FormsyPrismInput.propTypes = {
    ...PRISM_INPUT_PROPS,
    isValid: PropTypes.func.isRequired,
    isPristine: PropTypes.func.isRequired,
    isPaste: PropTypes.bool,
    getValue: PropTypes.func.isRequired,
    getErrorMessages: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
};

export default withFormsy(FormsyPrismInput);
